var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

// Script to open collection links in new tab
document.addEventListener("DOMContentLoaded", function () {
  const ELE = document.querySelectorAll(
    '[href*="/collections/"], [data-href*="/collections/"], summary[data-href*="/collections/"]'
  );
  ELE.forEach(function (element) {
    let f_Click = true;
    element.addEventListener("click", function (event) {
      if (element.tagName.toLowerCase() === "summary") {
        event.preventDefault();
      }
      event.stopImmediatePropagation();
      const url =
        element.getAttribute("href") || element.getAttribute("data-href");
      if (url) {
        if (f_Click) {
          window.open(url, "_blank");
          f_Click = false;
        } else {
          window.open(url, "_blank");
        }
      }
    });
    if (element.tagName.toLowerCase() === "a") {
      element.setAttribute("target", "_blank");
    }
  });
});
